import { IntegrationAuthApp } from '@prisma/client';
import { z } from 'zod';

export const emailSchema = z.string().email();

export const userEmail = z.object({
  email: emailSchema,
});

export const getSessionToken = z.object({
  integrations: z.custom<IntegrationAuthApp[]>(),
  integrationsConfigsDefaults: z.record(
    z.custom<IntegrationAuthApp>(),
    z.object({
      authorization_params: z.object({ scope: z.string() }),
    }),
  ),
});
